import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { User } from '../../../data/models/user.model';
import { UserRole } from '../../../data/models/user-role.model';

interface BasicInfoProps {
  user: User | null;
  titleStyle: string;
  loadingUserRoles: boolean;
  userRoles: UserRole[];
}

export default function BasicInfo({
  user,
  titleStyle,
  loadingUserRoles,
  userRoles,
}: BasicInfoProps) {
  const { t } = useTranslation('common');

  const [selectedRoles, setSelectedRoles] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (!loadingUserRoles && userRoles && user) {
      const roles: string[] = [];
      userRoles.forEach((r) => {
        const idx = (user.userCategoryTransportationProviders || []).findIndex(
          (c) => {
            return c.userRoleID === r.userRoleID;
          },
        );
        if (idx >= 0) {
          roles.push(r.userRoleName);
        }
      });
      setSelectedRoles(roles);
    }
  }, [loadingUserRoles, userRoles, user]);

  return (
    <>
      <Typography className={titleStyle}>{t('user.groups')}</Typography>
      {selectedRoles.map((r) => (
        <Typography key={r}>{r}</Typography>
      ))}
    </>
  );
}
